import { Address } from './address'

export type RealStateAddress = Nullable<{ asCustomerAddress: boolean }> & Address

function load(model?: Partial<RealStateAddress | Address> | null): RealStateAddress {
  return {
    asCustomerAddress: (model && 'asCustomerAddress' in model && model?.asCustomerAddress) ?? null,
    ...Address.load(model),
  }
}

const map = {
  toDireccionViewModel(model: RealStateAddress): SiteApiSchema<'DireccionViewModel'> {
    return {
      sectorId: model.sector?.id,
      sector: model.sector?.name,
      municipioId: model.municipality?.id,
      municipio: model.municipality?.name,
      provinciaId: model.province?.id,
      provincia: model.province?.name,
      calle: model.line1,
      departamento: model.line2,
    }
  },
}

export const RealStateAddress = {
  load,
  map,
}
